import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import CollectionRoute from "./viewMapRoute";
import { useGetCollectionDetailQuery } from "./collectionDetailSlice";
import SpinnerForPage from "../../components/spinner/SpinnerForPage";

export default function CollectionDetail() {
    const { id } = useParams();

    // Initialize navigate
    const navigate = useNavigate();
    // const { searchDatacollection } = useSelector((state) => state.auth);

    const {
        data: collectionDetail,
        isLoading,
    } = useGetCollectionDetailQuery(id);
    // console.log("collectionDetail",collectionDetail);
    // console.log("collectionDetail?.collection_details[0]?.collection_date",collectionDetail?.collection_details[0]?.collection_date);


    console.log("collectionDetail",collectionDetail?.collection_details?.[0]?.collection_start);

    return (
        <>
            {isLoading && <SpinnerForPage />}
            <div className="container-fluid p-3">
                <div className="row d-flex justify-content-between p-1">
                    <h4 className="col-5 heading_CollectionBox">Collection Details</h4>
                </div>
                <div className="list_Box row border m-auto shadow-sm d-flex p-4 rounded mt-4">
                    <p className="col-5 list_CollectionBox">{`Status: ${collectionDetail?.collection_details[0]?.status}`}</p>
                    <p className="col-5 list_CollectionBox">{`Category: ${collectionDetail?.collection_details[0]?.category}`}</p>
                    <p className="col-5 list_CollectionBox">{`Collection Date: ${moment(collectionDetail?.collection_details[0]?.collection_date).format('YYYY-MM-DD')}`}</p>
                    <p className="col-5 list_CollectionBox">{`Driver name: ${collectionDetail?.collection_details[0]?.p_name}`}</p>
                    <p className="col-5 list_CollectionBox">{`Driver number: ${collectionDetail?.collection_details[0]?.p_number}`}</p>
                    {/* <p className="col-5 list_CollectionBox">{`Helper name: ${collectionDetail?.collection_details[0]?.helper_name}`}</p> */}
                    {/* <p className="col-5 list_CollectionBox">{`Helper number: ${collectionDetail?.collection_details[0]?.helper_number}`}</p> */}
                    <p className="col-5 list_CollectionBox">{`IEC name: ${collectionDetail?.collection_details[0]?.inc_name}`}</p>
                    <p className="col-5 list_CollectionBox">{`IEc number: ${collectionDetail?.collection_details[0]?.inc_number}`}</p>
                    <p className="col-5 list_CollectionBox">{`Area: ${collectionDetail?.collection_details[0]?.area_name}  ${" " + collectionDetail?.collection_details[0]?.tag}`}</p>
                    <p className="col-5 list_CollectionBox">{`Started at: ${collectionDetail?.collection_details?.[0]?.collection_start ? new Date(collectionDetail.collection_details[0].collection_start).toISOString().slice(0, 19).replace('T', ' ') : 'Invalid date'}`}</p>
                    {/* <p className="col-5 list_CollectionBox">{`Completed at: ${moment(collectionDetail?.collection_details[0]?.collection_end).format('YYYY-MM-DD | hh:mm')}`}</p> */}
                    <p className="col-5 list_CollectionBox">{`Completed at: ${collectionDetail?.collection_details[0]?.collection_end ? new Date(collectionDetail?.collection_details[0]?.collection_end).toISOString().slice(0, 19).replace('T', ' ') : 'Invalid date'}`}</p>

                    {/* .replace(" ", "T")).toLocaleString("en-IN",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit",hour12:true} */}
                    <p className="col-5 list_CollectionBox">{`Vehicle Number: ${collectionDetail?.collection_details[0]?.vehicle_number}`}</p>
                    <p className="col-5 list_CollectionBox">{`Vehicle Name: ${collectionDetail?.collection_details[0]?.vehicle_name}`}</p>
                </div>

                {/* This is view map Route button */}
                <div className="button_Box view_route_buttone">
                    {collectionDetail?.collection_details[0] && collectionDetail?.collection_details[0]?.status === 'Completed' && (
                        <button className="button_all btn  button_Box "
                            onClick={() => (navigate(`/b2g/ViewMapRouteAnimation`, {
                                state: {
                                    id, collection_date: collectionDetail?.collection_details[0]?.collection_date, boundry: collectionDetail?.collection_details[0]?.boundry, start_location: collectionDetail?.collection_details[0]?.start_location, end_location: collectionDetail?.collection_details[0]?.end_location,
                                    geo_id: collectionDetail?.collection_details[0]?.geo_id, p_name: collectionDetail?.collection_details[0]?.p_name, area_name: collectionDetail?.collection_details[0]?.area_name, tag: collectionDetail?.collection_details[0]?.tag,
                                    assignment_id: collectionDetail?.collection_details[0]?.assignment_id
                                }
                            }))}
                        >View Route Animation</button>
                    )}
                </div>
            </div>

            {/* this page in view map Route */}
            <div className="mapCollectionDetails mb-5">
                <CollectionRoute geoId={collectionDetail?.recommended_path[0]?.geo_id} id={id} collection_date={collectionDetail?.collection_details[0]?.collection_date} boundry={collectionDetail?.collection_details[0]?.boundry} start_location={collectionDetail?.collection_details[0]?.start_location} end_location={collectionDetail?.collection_details[0]?.end_location} />
            </div>
        </>
    );
}